{
  "error": {
    "server_connection_failed": "Verbindung zum Server fehlgeschlagen."
  },
  "term": {
    "actuator_endpoint": "Actuator-Endpunkt",
    "affects_all_instances": "Betrifft alle {count} Instanzen",
    "affects_this_instance_only": "Betrifft nur diese Instanz",
    "all": "Alle",
    "application": "Anwendung",
    "attributes": "Attribute",
    "bytes": "Bytes",
    "cancel": "Abbrechen",
    "clear": "Leeren",
    "cleared": "Geleert",
    "close": "Schließen",
    "confirm": "Bestätigen",
    "delete": "Löschen",
    "deleted": "Gelöscht",
    "duration": "Dauer",
    "epoch_time": "Epoch Zeit",
    "percent": "Prozent",
    "event": "Ereignis",
    "ever": "immer",
    "executing": "Wird ausgeführt...",
    "execution_failed": "Ausführung fehlgeschlagen.",
    "execution_successful": "Ausführung erfolgreich.",
    "failed": "Fehlgeschlagen",
    "fetching_data": "Lade Daten...",
    "fetch_failed": "Abruf der Daten fehlgeschlagen.",
    "filter_action": {
      "reset": "Filter zurücksetzen"
    },
    "float": "Float",
    "homepage": "Startseite",
    "hours": "{count} Stunde | {count} Stunden",
    "instance": "Instanz",
    "instances": "Instanzen",
    "instances_tc": "{count} Instanz | {count} Instanzen",
    "integer": "Integer",
    "keyword_search": "Schlagwortsuche",
    "menu": {
      "open": "Menü öffnen"
    },
    "milliseconds": "Millisekunden",
    "minutes": "{count} Minute | {count} Minuten",
    "name": "Name",
    "operations": "Operationen",
    "save": "Speichern",
    "stacktrace": "Stacktrace",
    "suppress": "Unterdrücken",
    "time": "Zeit",
    "today": "Heute",
    "unsuppress": "Reaktivieren",
    "no_group": "Keine Gruppe",
    "username": "Username",
    "go_to_previous_page": "Gehe zur vorherigen Seite",
    "go_to_page_n": "Gehe zu Seite {page}",
    "current_page": "Seite {page}, aktuelle Seite",
    "go_to_next_page": "Gehe zur nächsten Seite",
    "no_results_for_term": "Keine Ergebnisse für \"{term}\"."
  },
  "health": {
    "label": "Zustand",
    "status": {
      "DOWN": "down",
      "UP": "up",
      "RESTRICTED": "eingeschränkt",
      "UNKNOWN": "unbekannt",
      "OUT_OF_SERVICE": "außer Betrieb",
      "OFFLINE": "offline"
    }
  },
  "time_short": {
    "unknown": "unbekannt",
    "milliseconds": "{count}ms",
    "seconds": "{count}s",
    "minutes": "{count}min",
    "hours": "{count}h",
    "days": "{count}d",
    "weeks": "{count}Wo",
    "months": "{count}Mo",
    "years": "{count}a"
  }
}
